import { FormControl, Validators } from '@angular/forms';
import { AlertType } from 'src/app/models/price-alert';
import { CustomValidators } from 'src/app/validators/custom-validators';
import { AlertForm } from './alert-form';
import { FormValidators } from 'src/app/validators/form-validators';

export class NumericAlertForm extends AlertForm {
  controlName = AlertType.NUMERIC;
  control = new FormControl(
    null,
    [Validators.required, CustomValidators.numberValidator, ,FormValidators.greaterThanZero]
  );
}
